// export const API_ENDPOINT = process.env.NODE_ENV === "production" ? "/" : "http://localhost:4000/api/v1";
// export const API_ENDPOINT = "http://localhost:4000/api/nvre/v1";
export const API_ENDPOINT = "https://api.siqisu.co.uk/api/nvre/v1";